import initStore from './initStore';
import actions from './actions';
import thunks from './thunks';

import { IDevicesModel } from './types';

const devices: IDevicesModel = {
  ...initStore,
  ...actions,
  ...thunks,
};

export default devices;
